var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as Actions from '../actions/tube.actions';
var initialState = {
    id: '',
    pathId: '',
    thumbnailOverlay: '',
    thumbnailLogo: '',
    logo: '',
    backgroundImage: '',
    color: '#9C3094',
    name: '',
};
var tube = function (state, action) {
    if (state === void 0) { state = initialState; }
    switch (action.type) {
        case Actions.SET_TUBE_DATA: {
            return __assign(__assign({}, initialState), __assign(__assign({}, action.payload), { color: action.payload.color || '#9C3094' }));
        }
        case Actions.UPDATE_TUBE: {
            return __assign(__assign({}, state), action.payload);
        }
        case Actions.SET_BRANDING_COLOR: {
            return __assign(__assign({}, initialState), { color: action.payload || '#9C3094' });
        }
        default: {
            return state;
        }
    }
};
export default tube;



//////////////////
// WEBPACK FOOTER
// ./src/auth/store/reducers/tube.reducer.ts
// module id = 1480
// module chunks = 81